import styled, { css } from "styled-components"
import Breakpoints from "./breakpoints"

export const LayoutContainer = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  position: relative;
  
  & .grid-container {
    margin: 0 20px;

    @media (min-width: ${Breakpoints.md}) {
      margin: 0 40px;
    }

    ${props =>
      !props.addMargin &&
      css`
        margin: 0 !important;
      `};
  }
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, [] 1fr);
  grid-column-gap: 12px;
  grid-auto-rows: min-content;

  z-index: 110;
  width: 100%;

  max-width: 1360px;

  @media screen and (min-width: ${Breakpoints.lg}) {
    grid-column-gap: 24px;
  }
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0px;
  z-index: 100;
  ${props => props.overlayStyle}
`
